import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import AudioConverter from './components/AudioConverter';
import AudioConverterPolly from './components/AudioConverterPolly';
import Login from './components/Login';
import Header from './components/Header';
import VideoAnnotator from './components/VideoAnnotator';
import { AuthProvider } from './context/authContext';
import {SrtGenerator} from './components/SrtGenerator'; 

function App() {
  return (
    <AuthProvider>
      <Router>
        <Header />
        <div
          className="app-container bg-cover bg-center min-h-screen flex flex-col backdrop-blur-lg bg-gradient-to-br from-gray-900 to-indigo-900"
        >

          <Routes>
            <Route path="/" element={<Home />} /> {/* Render nothing on the home route */}
            <Route path="/audio-converter" element={<AudioConverter />} />
            <Route path="/audio-converter-polly" element={<AudioConverterPolly />} />
            <Route path="/video-annotator" element={<VideoAnnotator />} />
            <Route path="/login" element={<Login />} />
            <Route path="/srt-generator" element={<SrtGenerator />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;